import {
  pure,
  compose
} from 'recompose'
import FieldGroup from './FieldGroup.js'

export default compose(
  pure
)(FieldGroup)



// WEBPACK FOOTER //
// ./components/uiLib/FieldGroup/index.js